var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var PaperclipIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 46,
    glyphHeight: 36
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 18C0 8.06 8.06 0 18 0H33.33C40.32 0 46 5.67 46 12.67C46 19.67 40.33 25.34 33.33 25.34H17.62C13.57 25.34 10.29 22.06 10.29 18.01C10.29 13.96 13.57 10.68 17.62 10.68H32.57C33.67 10.68 34.57 11.58 34.57 12.68C34.57 13.78 33.67 14.68 32.57 14.68H17.62C15.78 14.68 14.29 16.17 14.29 18.01C14.29 19.85 15.78 21.34 17.62 21.34H33.33C38.12 21.34 42 17.46 42 12.67C42 7.88 38.12 4 33.33 4H18C10.27 4 4 10.27 4 18C4 25.73 10.27 32 18 32H32.57C33.67 32 34.57 32.9 34.57 34C34.57 35.1 33.67 36 32.57 36H18C8.06 36 0 27.94 0 18Z",
    fill: "black"
  }));
};
export var PaperclipIconGlyph = function (props) {
  return React.createElement(PaperclipIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};